module.exports = __webpack_public_path__ + "static/Cascading_Stream05A_copy-813a216d6d2cd04fa3d7b9bf45003fe8.jpg";